module.exports = __webpack_public_path__ + "8a5356e9/img/file-icon.c085e21e.svg";